export default "__VITE_ASSET__COOtBH9t__"